import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import RightSideImageContactform from "../../assets/background_Image/homebg (2).jpg";
// import videoBg from "../../assets/background_Image/video2.mp4";

import "./contactForm.css";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
    country: "",
    date: "",
    time: "",
  });

  const validateEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const validatePhone = (phone) => {
    return /^[0-9]{10,15}$/.test(phone);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleDateChange = (date) => {
    setFormData({ ...formData, date });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateEmail(formData.email)) {
      alert("Please enter a valid email address.");
      return;
    }
    if (!validatePhone(formData.phone)) {
      alert("Please enter a valid phone number (10-15 digits).");
      return;
    }
    console.log("Form submitted:", formData);
    alert("Thank you! We'll confirm your appointment via email.");
    // Add actual email notification and backend integration here
  };

  return (
    <div className="stepper-container">
      <div className="stepper-image">
        <img src={RightSideImageContactform} alt="Contact Illustration" />
        {/* <video autoPlay muted loop playsInline className="stepper-video">
          <source src={videoBg} type="video/mp4" />
        </video> */}
      </div>

      <div className="stepper-form-container">
        <h2 className="stepper-form-title">
          Get in touch to discuss your project, request a quote or even just to
          pick our brains.
        </h2>

        <form onSubmit={handleSubmit} className="stepper-form">
          <input
            type="text"
            name="name"
            placeholder="Full Name"
            value={formData.name}
            onChange={handleChange}
            required
          />
          <input
            type="email"
            name="email"
            placeholder="Email Address"
            value={formData.email}
            onChange={handleChange}
            required
          />
          <input
            type="text"
            name="country"
            placeholder="Country"
            value={formData.country}
            onChange={handleChange}
            required
          />
          <input
            type="tel"
            name="phone"
            placeholder="Phone Number"
            value={formData.phone}
            onChange={handleChange}
            required
          />
          <textarea
            name="message"
            placeholder="Describe Your Project Briefly..."
            value={formData.message}
            onChange={handleChange}
            rows={4}
          />

          <div className="stepper-row">
            <div style={{ flex: 1 }}>
              <label>Preferred Date</label>
              <DatePicker
                selected={formData.date}
                onChange={handleDateChange}
                placeholderText="Select a Date"
                className="stepper-datepicker"
                required
              />
            </div>

            <div style={{ flex: 1 }}>
              <label>Preferred Time</label>
              <input
                type="time"
                name="time"
                value={formData.time}
                onChange={handleChange}
                placeholderText="Select a Time"
                required
              />
            </div>
          </div>
          <button type="submit" className="stepper-button">
            Book My Free Consultation
          </button>
        </form>
      </div>
    </div>
  );
};

export default ContactForm;
